/* Joyeux Marché — module « merveilles » (30/10). Sans dépendance, respecte « animations réduites ».
   1. Ciel vivant du hero : nuages le jour, aurores boréales au crépuscule et la nuit, constellation du sapin.
   2. Fiche produit « Idée cadeau » : le ruban se dénoue et s'envole (une fois par fiche et par visite).
   3. Mobile : secouer le téléphone fait neiger plus fort (Android direct, iPhone après accord).
   4. Jours spéciaux : 1er décembre (début de l'Avent) et 6 décembre (Saint-Nicolas). */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var coarse = window.matchMedia ? matchMedia('(pointer: coarse)') : { matches: false };
  function reduced() { return mq.matches || root.classList.contains('jm-reduced'); }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function monthDay() { var t = (window.JM && JM.today) || 0; return t % 10000; }
  function toast(msg) {
    if (window.JMFeerie && JMFeerie.toast) { JMFeerie.toast(msg, 5200); return; }
  }
  var NS = 'http://www.w3.org/2000/svg';

  /* 1. Ciel vivant du hero */
  function sky() {
    var hero = d.querySelector('.jm-hero'); if (!hero || hero.querySelector('.jm-aurora')) return;
    var base = hero.querySelector('.jm-hero__sky');
    var after = base ? base.nextSibling : hero.firstChild;
    /* Nuages (visibles le jour) */
    var clouds = d.createElement('div'); clouds.className = 'jm-clouds'; clouds.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 4; i++) {
      var c = d.createElement('i');
      c.style.setProperty('--y', (3 + i * 4.5 + Math.random() * 3).toFixed(1) + '%');
      c.style.setProperty('--sc', (0.45 + Math.random() * 0.4).toFixed(2));
      c.style.setProperty('--t', (70 + Math.random() * 50).toFixed(0) + 's');
      c.style.setProperty('--dl', (-Math.random() * 110).toFixed(0) + 's');
      clouds.appendChild(c);
    }
    /* Aurores boréales (crépuscule et nuit) */
    var au = d.createElement('div'); au.className = 'jm-aurora'; au.setAttribute('aria-hidden', 'true');
    au.innerHTML = '<i></i><i></i><i></i>';
    hero.insertBefore(au, after);
    hero.insertBefore(clouds, au);
    /* Constellation du sapin (nuit) : 9 étoiles reliées, l'étoile du sommet dorée */
    var pts = [[50, 6], [38, 30], [62, 30], [30, 52], [70, 52], [20, 76], [80, 76], [42, 76], [58, 76]];
    var lines = [[0, 1], [0, 2], [1, 3], [2, 4], [3, 5], [4, 6], [5, 7], [6, 8], [1, 2], [3, 4]];
    var svg = d.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'jm-constellation'); svg.setAttribute('viewBox', '0 0 100 90'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    lines.forEach(function (l, k) {
      var ln = d.createElementNS(NS, 'line');
      ln.setAttribute('x1', pts[l[0]][0]); ln.setAttribute('y1', pts[l[0]][1]); ln.setAttribute('x2', pts[l[1]][0]); ln.setAttribute('y2', pts[l[1]][1]);
      ln.setAttribute('pathLength', '1'); ln.style.setProperty('--i', k);
      svg.appendChild(ln);
    });
    pts.forEach(function (p, k) {
      var s = d.createElementNS(NS, 'circle');
      s.setAttribute('cx', p[0]); s.setAttribute('cy', p[1]); s.setAttribute('r', k === 0 ? 2.6 : 1.5);
      if (k === 0) s.setAttribute('class', 'is-top');
      s.style.setProperty('--i', k);
      svg.appendChild(s);
    });
    var stars = hero.querySelector('.jm-hero__stars');
    hero.insertBefore(svg, stars ? stars.nextSibling : au.nextSibling);
    /* La constellation se dessine quand le hero est visible, une fois le ciel de nuit posé */
    if (!('IntersectionObserver' in window)) { svg.classList.add('is-drawn'); return; }
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return; io.disconnect();
      setTimeout(function () { svg.classList.add('is-drawn'); }, reduced() ? 0 : 1600);
    }, { threshold: 0.3 });
    io.observe(hero);
  }

  /* 2. Fiche produit : le ruban du cadeau se dénoue */
  var BOW = '<svg class="jm-unwrap__bow" viewBox="0 0 120 84" aria-hidden="true" focusable="false">' +
    '<path d="M60 40 C40 6 6 8 10 30 C13 48 40 48 60 40Z" fill="#B3202A"/>' +
    '<path d="M60 40 C80 6 114 8 110 30 C107 48 80 48 60 40Z" fill="#B3202A"/>' +
    '<path d="M60 40 C46 18 22 16 22 30 C22 40 42 42 60 40Z" fill="#8c1820" opacity=".55"/>' +
    '<path d="M60 40 C74 18 98 16 98 30 C98 40 78 42 60 40Z" fill="#8c1820" opacity=".55"/>' +
    '<path d="M56 44 L40 82 L50 76 L56 84 L62 46Z" fill="#B3202A"/>' +
    '<path d="M64 44 L80 82 L70 76 L64 84 L58 46Z" fill="#9c1b24"/>' +
    '<rect x="51" y="31" width="18" height="17" rx="6" fill="#d4434b"/>' +
    '<path d="M55 35 q5 -3 10 0" stroke="#f3b3b6" stroke-width="2" fill="none" stroke-linecap="round"/>' +
    '</svg>';
  function unwrap() {
    if (reduced()) return;
    var m = location.pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)/i); if (!m) return;
    var gallery = d.querySelector('main media-gallery, main .product-information media-gallery'); if (!gallery) return;
    var handle = m[1].toLowerCase(), key = 'jm_unwrap_' + handle;
    var count = +(sget('jm_unwrap_n') || 0);
    if (sget(key) || count >= 5) return;
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p || !p.tags || p.tags.indexOf('Idée cadeau') === -1) return;
      var slides = [].slice.call(gallery.querySelectorAll('.product-media'));
      var box = null, best = 0;
      slides.forEach(function (s) {
        var r = s.getBoundingClientRect();
        var vis = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0)) * Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
        if (vis > best) { best = vis; box = s; }
      });
      if (!box || best < 20000) return;
      sset(key, '1'); sset('jm_unwrap_n', String(count + 1));
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var w = d.createElement('div'); w.className = 'jm-unwrap'; w.setAttribute('aria-hidden', 'true');
      w.innerHTML = '<i class="jm-unwrap__v"></i><i class="jm-unwrap__h"></i>' + BOW + '<span class="jm-unwrap__spark"></span>';
      box.appendChild(w);
      var img = box.querySelector('img');
      function go() {
        requestAnimationFrame(function () { w.classList.add('is-go'); });
        setTimeout(function () { w.remove(); }, 2400);
      }
      /* On attend que la photo soit chargée (ou 1,5 s au plus) */
      if (img && !img.complete) { var done = false; var fire = function () { if (!done) { done = true; setTimeout(go, 350); } }; img.addEventListener('load', fire, { once: true }); setTimeout(fire, 1500); }
      else setTimeout(go, 450);
    }).catch(function () {});
  }

  /* 3. Secouer le téléphone : la neige redouble (et la boule à neige se secoue si elle est là) */
  var shakeOn = false;
  function onShake() {
    if (reduced()) return;
    var g = d.querySelector('[data-jm-globe]'), r = g ? g.getBoundingClientRect() : null;
    if (g && r.bottom > 0 && r.top < innerHeight) { g.click(); return; }
    if (window.JMSnow) JMSnow.gust(innerWidth / 2, innerHeight * 0.25, 40, 70);
  }
  function listenMotion() {
    if (shakeOn) return; shakeOn = true;
    var lx = null, ly = 0, lz = 0, hits = 0, hitT = 0, last = 0;
    addEventListener('devicemotion', function (e) {
      var a = e.accelerationIncludingGravity; if (!a || a.x == null) return;
      if (lx !== null) {
        var delta = Math.abs(a.x - lx) + Math.abs(a.y - ly) + Math.abs(a.z - lz), now = Date.now();
        if (delta > 24) {
          if (now - hitT > 700) hits = 0;
          hits++; hitT = now;
          if (hits >= 3 && now - last > 1800) { last = now; hits = 0; onShake(); }
        }
      }
      lx = a.x; ly = a.y; lz = a.z;
    }, { passive: true });
  }
  function askMotion() {
    /* iPhone : l'accès aux mouvements se demande seulement après un geste du visiteur */
    if (sget('jm_motion_ask')) return; sset('jm_motion_ask', '1');
    var bar = d.createElement('div'); bar.className = 'jm-ask'; bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', 'Secouer le téléphone');
    bar.innerHTML = '<span>Envie de secouer ton téléphone pour faire neiger ?</span><button type="button" data-yes>Oui !</button><button type="button" class="jm-ask__no" data-no aria-label="Non merci">×</button>';
    d.body.appendChild(bar);
    var t = setTimeout(close, 9000);
    function close() { clearTimeout(t); bar.classList.add('is-out'); setTimeout(function () { bar.remove(); }, 400); }
    bar.querySelector('[data-no]').addEventListener('click', close);
    bar.querySelector('[data-yes]').addEventListener('click', function () {
      close();
      try {
        DeviceMotionEvent.requestPermission().then(function (s) {
          if (s === 'granted') { listenMotion(); toast('C\'est parti : secoue ton téléphone, il va neiger !'); }
        }).catch(function () {});
      } catch (e) {}
    });
  }
  function motion() {
    if (!coarse.matches || !('DeviceMotionEvent' in window) || reduced()) return;
    /* Android : les mouvements arrivent directement. iPhone et iPad : rien n'arrive tant que le visiteur n'a pas accepté */
    listenMotion();
    var ios = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (ios && typeof DeviceMotionEvent.requestPermission === 'function') {
      d.addEventListener('click', function (e) {
        if (e.isTrusted && e.target.closest && e.target.closest('[data-jm-globe]')) setTimeout(askMotion, 900);
      });
    }
  }

  /* 4. Jours spéciaux */
  var GINGER = [
    '<svg viewBox="0 0 24 28" aria-hidden="true"><path d="M12 1.5a4.2 4.2 0 0 1 3.3 6.8h4.4a2.1 2.1 0 0 1 0 4.2H16l2.7 7.6a2.1 2.1 0 0 1-4 1.4L12 17.2l-2.7 4.3a2.1 2.1 0 0 1-4-1.4L8 12.5H4.3a2.1 2.1 0 0 1 0-4.2h4.4A4.2 4.2 0 0 1 12 1.5z" fill="#a0612e"/><circle cx="10.4" cy="5.3" r=".9" fill="#fff"/><circle cx="13.6" cy="5.3" r=".9" fill="#fff"/><path d="M10.3 7.2q1.7 1.2 3.4 0" stroke="#fff" stroke-width=".8" fill="none"/><circle cx="12" cy="11" r=".9" fill="#B3202A"/><circle cx="12" cy="14" r=".9" fill="#1E4D3B"/><path d="M5 10.4h2M17 10.4h2" stroke="#fff" stroke-width=".8" stroke-linecap="round"/></svg>',
    '<svg viewBox="0 0 24 22" aria-hidden="true"><path d="M12 21 C3 14 1 10 1 6.5 A5.3 5.3 0 0 1 12 4 A5.3 5.3 0 0 1 23 6.5 C23 10 21 14 12 21Z" fill="#9a5a2a"/><path d="M5 7.5 l2 -2 2 2 2 -2 2 2 2 -2 2 2 2 -2" stroke="#fff" stroke-width=".9" fill="none" stroke-linejoin="round"/><circle cx="12" cy="13" r="1.4" fill="#B3202A"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.5l3 6.6 7.1.7-5.4 4.8 1.6 7-6.3-3.7-6.3 3.7 1.6-7L1.9 8.8 9 8.1z" fill="#a8672f"/><path d="M12 4.6l2.1 4.6 5 .5-3.8 3.4 1.1 4.9L12 15.4 7.6 18l1.1-4.9-3.8-3.4 5-.5z" fill="none" stroke="#fff" stroke-width=".8" stroke-dasharray="1.6 1.2"/></svg>'
  ];
  function rain(hero, items, n, cls) {
    var h = hero.offsetHeight;
    for (var i = 0; i < n; i++) {
      var s = d.createElement('span'); s.className = 'jm-treat ' + (cls || ''); s.setAttribute('aria-hidden', 'true');
      s.innerHTML = items[i % items.length];
      s.style.setProperty('--x', (Math.random() * 100).toFixed(1) + '%');
      s.style.setProperty('--s', (18 + Math.random() * 16).toFixed(0) + 'px');
      s.style.setProperty('--t', (2.8 + Math.random() * 2).toFixed(2) + 's');
      s.style.setProperty('--dl', (Math.random() * 2.4).toFixed(2) + 's');
      s.style.setProperty('--dx', (Math.random() * 80 - 40).toFixed(0) + 'px');
      s.style.setProperty('--fall', (h * (0.6 + Math.random() * 0.35)).toFixed(0) + 'px');
      s.style.setProperty('--r', (Math.random() * 300 - 150).toFixed(0) + 'deg');
      hero.appendChild(s);
    }
    setTimeout(function () { hero.querySelectorAll('.jm-treat').forEach(function (x) { x.remove(); }); }, 6000);
  }
  function specialDays() {
    if (reduced()) return;
    var hero = d.querySelector('.jm-hero'); if (!hero) return;
    var md = monthDay(), small = innerWidth < 750;
    if (md === 1206 && !sget('jm_nicolas')) {
      sset('jm_nicolas', '1');
      setTimeout(function () { rain(hero, GINGER, small ? 16 : 28); }, 900);
      setTimeout(function () { toast('Bonne Saint-Nicolas ! Une pluie de pains d\'épices pour fêter ça.'); }, 1400);
    }
    if (md === 1201 && !sget('jm_avent1')) {
      sset('jm_avent1', '1');
      var GOLD = ['<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17l-6.1 3.4 1.5-6.8L2.2 9l6.9-.7z" fill="#E7C37A"/></svg>', '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="6" fill="#C99A3B"/><circle cx="10" cy="10" r="2" fill="#FBF0D0"/></svg>', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v18M3 12h18M6 6l12 12M18 6L6 18" stroke="#FBF7EF" stroke-width="2" stroke-linecap="round"/></svg>'];
      setTimeout(function () { rain(hero, GOLD, small ? 18 : 32, 'is-gold'); }, 900);
      setTimeout(function () { toast('Le 1er décembre est arrivé : c\'est le début de l\'Avent !'); }, 1400);
    }
  }

  /* Petit plus : le bouton neige explique que la neige s'intensifie à l'approche de Noël */
  function snowHint() {
    d.querySelectorAll('[data-jm-snow-toggle]').forEach(function (b) { if (!b.title) b.title = 'Plus Noël approche, plus il neige sur le marché'; });
  }

  function init() { sky(); unwrap(); motion(); specialDays(); snowHint(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
